import { render } from "./DetailTrainer.vue?vue&type=template&id=3ab247b8"
import script from "./DetailTrainer.vue?vue&type=script&lang=js"
export * from "./DetailTrainer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/teguhsangra/Web/GSD/xsport/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__